import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {warnAlert} from '../actions/alertsActions';
import commonMessages from '../intl/common/commonMessages';

class NotFoundPage extends Component {
    componentDidMount() {
        this.props.warnAlert(commonMessages.PAGE_DOES_NOT_EXIST);
    }

    render = () => (
        <div>
        </div>
    );
}

NotFoundPage.propTypes = {
    warnAlert: PropTypes.func.isRequired
};

const mapStateToProps = state => ({});

export default connect(mapStateToProps, {
    warnAlert
})(NotFoundPage);
